import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, onBeforeMount, ref } from "vue";
import { useColors } from "@/common/composables/colors";
import { toCssSizeUnit, pxToRem } from "@/common/helpers/style";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecCard',
    props: {
        height: { default: "100%" },
        width: { default: "100%" },
        elevation: { type: Boolean, default: false },
        borderRadius: { default: 4 },
        color: { default: "white" },
        padding: { default: 40 }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "v18b1c99a": (paddingCss.value),
            "v4c9d9c3b": (heightCss.value),
            "v70d49d9e": (widthCss.value),
            "v7e55bee4": (borderRadiusCss.value)
        }));
        const props = __props;
        // Helpers
        const { isValidMDColor } = useColors();
        // Props validation
        const colorPropIsValid = ref(false);
        onBeforeMount(async () => {
            colorPropIsValid.value = await isValidMDColor(props.color);
            if (!colorPropIsValid.value) {
                console.warn(`"${props.color}" passed to RecCard's "color" prop is not a valid MD color`);
            }
        });
        // Computed refs
        const heightCss = computed(() => (props.height === "auto" ? props.height : toCssSizeUnit(props.height)));
        const widthCss = computed(() => (props.width === "auto" ? props.width : toCssSizeUnit(props.width)));
        const paddingCss = computed(() => pxToRem(props.padding));
        const borderRadiusCss = computed(() => pxToRem(props.borderRadius));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({
                    'rec-card bg-white': true,
                    'rec-card--elevated': __props.elevation,
                    [`bg-${colorPropIsValid.value ? __props.color : 'white'}`]: true
                })
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
